import { type FC, memo } from "react";
import { Button, ButtonKind, ButtonSize, ButtonVariant, Text } from "@stubhub/broadway-web";
import { Content } from "src/shared/components/content";
import { emptyStateStyles } from "./styles";

interface Props {
  resetFilters: () => void;
}

export const ResidencyMobileEmptyState: FC<Props> = memo(({ resetFilters }) => (
  <div className={emptyStateStyles.container}>
    <Text variant="label" size="small">
      <Content id="cid$#4000951#" /> {/* No events within your filters. */}
    </Text>
    <Button
      kind={ButtonKind.Neutral}
      variant={ButtonVariant.Outline}
      size={ButtonSize.Small}
      onClick={resetFilters}
      classes={{ root: emptyStateStyles.button }}
    >
      <Content id="cid$#3637096#" /> {/* Reset filters */}
    </Button>
  </div>
));

ResidencyMobileEmptyState.displayName = "ResidencyMobileEmptyState";
